import React, { FunctionComponent } from 'react';

import classnames from 'classnames';

import { Number } from 'core/number/Number';
import { RatingValueProps } from 'core/rating/types';
import { parseSize, parseValueMax, DEFAULT_COLOR_FULL, applyColorProp, parseColorFull } from 'core/rating/util/Props';
import { isUnrated } from 'core/rating/util/Values';

import 'core/rating/rating-value/RatingValue.scss';

export const RatingValue: FunctionComponent<RatingValueProps> = ({
    className,
    colorFull: colorFullFropProps,
    selectedValue,
    size: sizeFromProps,
    valueMax: valueMaxFromProps,
    numberFormat,
}) => {
    const colorFull = applyColorProp(parseColorFull(colorFullFropProps), selectedValue);
    const size = parseSize(sizeFromProps);
    const valueMax = parseValueMax(valueMaxFromProps);
    const isNoRating = isUnrated(selectedValue);

    const renderRatingValue = () => {
        if (isNoRating) {
            return <>-</>;
        }
        if (numberFormat) {
            return <Number value={selectedValue as number} precision={1} />;
        }
        return <span className="float-value-selected">{selectedValue?.toFixed(1)}</span>;
    };

    return (
        <div className={classnames(`r4e-rating-value size-${size}`, className, { 'state-unrated': isNoRating })}>
            <span className="value-selected" style={{ color: colorFull }}>
                {renderRatingValue()}
            </span>
            {!isNoRating && (
                <span className="value-max">
                    /<Number value={valueMax as number} precision={1} />
                </span>
            )}
        </div>
    );
};

RatingValue.defaultProps = {
    className: undefined,
    colorFull: DEFAULT_COLOR_FULL,
    selectedValue: undefined,
    size: parseSize(),
    valueMax: parseValueMax(),
    numberFormat: true,
};
